import React from 'react';
import { Header, Image, Divider } from 'semantic-ui-react';
import { CreditCardForm, PlanDetail } from '@emyw/pay-lib';
import { getLocalStorageWithExpiry } from '@emyw/core-lib';
import { ButtonLink } from '@emyw/auth-lib';
import { getPlanCostLabel, DEFAULT_PROMO_CODE } from '../utils';
import '../custom-theme.css';
var REACT_APP_ACCOUNT_API_IMAGE_PATH = process.env.REACT_APP_ACCOUNT_API_IMAGE_PATH;

var Step3CardInfo = function Step3CardInfo(_ref) {
  var onComplete = _ref.onComplete,
      onChangePlanClick = _ref.onChangePlanClick,
      onChangePaymentClick = _ref.onChangePaymentClick,
      user = _ref.user,
      planSelectDisabled = _ref.planSelectDisabled,
      darkMode = _ref.darkMode;
  // let monthlyCostMessage;
  // if (getLocalStorageWithExpiry('enjoy-promo-code') === DEFAULT_PROMO_CODE) {
  var monthlyCostMessage = /*#__PURE__*/React.createElement("i", {
    style: {
      fontSize: '0.9em'
    }
  }, /*#__PURE__*/React.createElement("br", null), "[first 7 days free]"); // }

  var planCostLabel = getPlanCostLabel(user);
  var planMessage = /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("b", null, planCostLabel.label1, (planCostLabel.label1 || '').toLowerCase().indexOf('free') > -1 && /*#__PURE__*/React.createElement("sup", null, "*")), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("b", null, planCostLabel.label2, (planCostLabel.label2 || '').toLowerCase().indexOf('free') > -1 && /*#__PURE__*/React.createElement("sup", null, "*"))); // Show plan cost label here since PlanDetail won't be used below

  return /*#__PURE__*/React.createElement("div", {
    className: "wizardStepBase cardInfo"
  }, /*#__PURE__*/React.createElement(Header, {
    color: "grey",
    as: "h2",
    textAlign: "center"
  }, /*#__PURE__*/React.createElement(Image, {
    size: "large",
    src: "".concat(REACT_APP_ACCOUNT_API_IMAGE_PATH, "/circle-secure.png")
  }), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "stepTitleChangeable"
  }, "Set up your credit or debit card.", /*#__PURE__*/React.createElement(Header.Subheader, {
    className: "stepChange"
  }, /*#__PURE__*/React.createElement(ButtonLink, {
    onClick: onChangePaymentClick
  }, "Change payment method")), planSelectDisabled && /*#__PURE__*/React.createElement(Header.Subheader, null, planMessage))), !planSelectDisabled && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement(PlanDetail, {
    user: user,
    secondary: true,
    onChangePlanClick: onChangePlanClick,
    monthlyCostMessage: monthlyCostMessage
  })), /*#__PURE__*/React.createElement(Divider, {
    hidden: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "subscribeStepContent"
  }, /*#__PURE__*/React.createElement(CreditCardForm, {
    onComplete: onComplete
    /* onChangePlanClick={onChangePlanClick} */
    ,
    user: user,
    darkMode: darkMode
  })), /*#__PURE__*/React.createElement(Header, {
    color: "grey",
    as: "h2",
    textAlign: "center",
    style: {
      height: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "stepTitle"
  }, /*#__PURE__*/React.createElement(Header.Subheader, null, (planCostLabel.label2 || '').toLowerCase().indexOf('free') > -1 && /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '0.85em'
    }
  }, /*#__PURE__*/React.createElement("sup", null, "*"), " No charges processed unless remaining on paid plan after trial.")))));
};

Step3CardInfo.defaultProps = {
  darkMode: false
};
export default Step3CardInfo;